import React from "react";
import _ from "lodash";
import { compose } from "recompose";
import { MessageDescriptor } from "react-intl";

import { Select, SelectProps } from "@ui/Select";
import { withDsps, InjectedDspsProps } from "@dsps/components/withDsps";
import { Dsp } from "../../models";

type Props = InjectedDspsProps;

interface OuterProps {
    selected: number | number[];
    multiple?: boolean;
    placeholder?: string;
    placeholderMessage?: MessageDescriptor;
    onChange?: (id: number | number[]) => void;
    id?: string;
}

type SelectDsp = typeof Select<Dsp>;
const SelectDsp = Select as SelectDsp;

class DspSelect extends React.Component<Props & OuterProps> {
    private handleChange(option: Dsp | Dsp[]) {
        const { onChange } = this.props;
        if (this.props.onChange != null) {
            if (Array.isArray(option)) {
                onChange(_.map(option, (type) => type.id));
            }
            else if (option != null) {
                onChange(option.id);
            }
            else {
                onChange(null);
            }
        }
    }

    public render() {
        const {
            dsps,
            selected,
            multiple,
            placeholder,
            placeholderMessage,
            id,
        } = this.props;
        let value: Dsp[] = [];
        if (Array.isArray(selected)) {
            value = _.map(selected, (dspId) => _.find(dsps, ["id", dspId]));
        }
        else {
            value = [_.find(dsps, ["id", selected])];
        }
        const props: SelectProps<Dsp> = {
            getOptionValue: (dsp) => String(dsp.id),
            getOptionLabel: (dsp) => dsp.name,
            isMulti: multiple != null && multiple === true,
            value,
            options: dsps,
            onChange: this.handleChange.bind(this),
            inputId: id,
        };
        if (placeholder != null) {
            props.placeholder = placeholder;
        }
        if (placeholderMessage != null) {
            props.placeholderMessage = placeholderMessage;
        }
        return (
            <div className="type-select">
                <SelectDsp {...props}/>
            </div>
        );
    }
}

const ConnectedDspSelect = compose<Props, OuterProps>(
    withDsps,
)(DspSelect);

export {
    DspSelect as DspSelectPresenter,
    ConnectedDspSelect as DspSelect,
};
